// Shared practice-loop types. The orchestrator + each extracted
// component / hook reaches in here so a question shape change is one
// edit, not a hunt across files.

export type ChoiceLabel = "A" | "B" | "C" | "D";

export interface Choice {
  label: ChoiceLabel;
  text: string;
}

export interface Question {
  id: string;
  topicId: string;
  topicLabel: string;
  stem: string;
  choices: Choice[];
  difficulty: number;
}

export interface SubmitResult {
  correct: boolean;
  correctLabel: ChoiceLabel;
  explanation: string;
}

export interface TutorMessage {
  role: "user" | "assistant";
  content: string;
}

export interface EntitlementCheck {
  hasAccess: boolean;
  tier: "PAID" | "FREE" | "EXHAUSTED";
  freeTier: { used: number; remaining: number; limit: number } | null;
}

// Brief: "After 4 turns, 'I think I get it' button appears". The
// server enforces this same cap; this constant just keeps the client
// UI in sync so we hide the input at the right moment.
export const TUTOR_TURN_CAP = 4;

export type ReportReason =
  | "wrong-answer"
  | "ambiguous"
  | "outdated"
  | "leaks-rationale"
  | "other";

export const REPORT_REASONS: ReadonlyArray<{
  value: ReportReason;
  label: string;
}> = [
  { value: "wrong-answer", label: "Answer is wrong" },
  { value: "ambiguous", label: "Question or choices are ambiguous" },
  { value: "outdated", label: "Information is outdated" },
  { value: "leaks-rationale", label: "Choice text reveals the answer" },
  { value: "other", label: "Other" },
];

export interface PracticeScore {
  correct: number;
  total: number;
}

export function makeSessionId(): string {
  return `sess_${Math.random().toString(36).slice(2, 12)}_${Date.now()}`;
}
